import { render, staticRenderFns } from "./LetterDeliveryPage.vue?vue&type=template&id=31b14c20&"
import script from "./LetterDeliveryPage.vue?vue&type=script&lang=js&"
export * from "./LetterDeliveryPage.vue?vue&type=script&lang=js&"
import style0 from "./LetterDeliveryPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports